const auth = {
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset Password',
    tenantCode: 'Tenant Code',
    loginError: 'Login failed',
    invalidCredentials: 'Invalid email or password',
    // Server error codes — loginError is the unknown-code fallback
    errorCodes: {
      AUTH_INVALID_CREDENTIALS: 'Invalid email or password',
      AUTH_MFA_REQUIRED: 'Verification code is required',
      AUTH_INVALID_MFA: 'Verification code is incorrect. Please try again.',
      AUTH_TENANT_CODE_REQUIRED: 'Tenant code is required',
      AUTH_DOCUMENT_TENANT_MISMATCH:
        'The selected user belongs to a different tenant than this document',
    },
    // Login Page
    signInPrompt: 'Sign in to your account',
    signIn: 'Sign In',
    emailAddress: 'Email Address',
    tenantCodePlaceholder: 'e.g., ACME',
    emailPlaceholder: 'user@example.com',
    togglePasswordVisibility: 'Toggle password visibility',
    // Forgot Password Page
    forgotPasswordTitle: 'Forgot Password?',
    forgotPasswordDescription: "Enter your email address and tenant code. We'll send you a link to reset your password.",
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    checkYourEmail: 'Check Your Email',
    resetLinkSent: "We've sent a password reset link to",
    checkSpamFolder: "If you don't see the email, please check your spam folder.",
    // Reset Password Page
    resetPasswordTitle: 'Reset Your Password',
    resetPasswordDescription: 'Enter your new password below.',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    passwordResetSuccess: 'Password Reset Successful',
    passwordResetSuccessMessage: 'Your password has been successfully reset. You can now sign in with your new password.',
    goToLogin: 'Go to Login',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordRequirementsNotMet: 'Password does not meet the minimum security requirements.',
    invalidResetToken: 'Invalid or missing reset token. Please request a new password reset.',
    resetLinkExpired: 'Failed to reset password. The reset link may have expired.',
    // Password requirements
    passwordRequirements: 'Password Requirements:',
    minLength: 'At least 8 characters',
    hasUpperCase: 'One uppercase letter',
    hasLowerCase: 'One lowercase letter',
    hasNumber: 'One number',
    hasSpecial: 'One special character',
    // Form validation
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email address',
    passwordRequired: 'Password is required',
    tenantCodeRequired: 'Tenant code is required',
    sendResetLinkError: 'Failed to send the reset link. Please try again.',
    // Login heading (Type A)
    signInTitle: 'Welcome back',
    signInSubtitle: 'Sign in to your knowledge workspace',
    // The brand panel carries no copy — see BrandPanel.tsx. Its former headline,
    // subtitle, feature bullets and copyright keys were removed with it rather
    // than left orphaned; the approved left-half visual will bring its own.
  };

export default auth;
